import type { SvgIconProps } from '@mui/material/SvgIcon';
import type { Theme, SxProps } from '@mui/material/styles';

import * as React from "react";
import { forwardRef } from 'react';

import SvgIcon from '@mui/material/SvgIcon';

// ----------------------------------------------------------------------

const baseStyles: SxProps<Theme> = {
  width: 20,
  height: 'auto',
  flexShrink: 0,
};

// ----------------------------------------------------------------------

export const WorkflowIcon = forwardRef<SVGSVGElement, SvgIconProps>((props, ref) => {
  const { sx, ...other } = props;

  return (
    <SvgIcon
      ref={ref}
      sx={[
        () => ({
          ...baseStyles,
          color: '#9747FF',
        }),
        ...(Array.isArray(sx) ? sx : [sx]),
      ]}
      {...other}
      viewBox="0 0 59 58"
    >
      <path
        fill="var(--color, currentColor)"
        d="M4.865 21.75a2.72 2.72 0 0 1-2.72-2.719v-14.5a2.72 2.72 0 0 1 2.72-2.718h14.5a2.72 2.72 0 0 1 2.718 2.718v14.5a2.72 2.72 0 0 1-2.718 2.719zM39.302 56.188a2.72 2.72 0 0 1-2.719-2.72v-14.5a2.72 2.72 0 0 1 2.72-2.718h14.5a2.72 2.72 0 0 1 2.718 2.719v14.5a2.72 2.72 0 0 1-2.719 2.718zM45.898 20.648c.1.47.77.47.871 0a10.7 10.7 0 0 1 8.212-8.212c.47-.101.47-.77 0-.872a10.7 10.7 0 0 1-8.212-8.212c-.1-.47-.77-.47-.871 0a10.7 10.7 0 0 1-8.213 8.212c-.469.101-.469.77 0 .872a10.7 10.7 0 0 1 8.213 8.212"
      />
      <path
        fill="var(--color, currentColor)"
        d="M10.568 26.016a.906.906 0 0 0 1.281 0l.266-.266v6.875a.906.906 0 0 0 1.812 0V25.75l.266.266a.906.906 0 0 0 1.281-1.282L13.67 22.93a.9.9 0 0 0-.645-.273h-.017a.9.9 0 0 0-.627.266l-1.812 1.812a.906.906 0 0 0 0 1.282M47.724 30.172a.906.906 0 0 1 1.282 1.281l-1.813 1.813a.903.903 0 0 1-1.289-.008l-1.805-1.805a.906.906 0 0 1 1.282-1.281l.265.265v-6.875a.906.906 0 1 1 1.812 0v6.875z"
      />
      <path
        fill="var(--color, currentColor)"
        d="M13.02 55.281c-5.505 0-9.968-4.463-9.968-9.968 0-5.506 4.463-9.97 9.969-9.97s9.969 4.464 9.969 9.97c0 5.505-4.464 9.968-9.97 9.968"
      />
      <path
        fill="var(--color, currentColor)"
        d="M31.411 9.328a.906.906 0 0 0 0 1.282l.266.265h-6.875a.906.906 0 1 0 0 1.813h6.875l-.266.265a.906.906 0 0 0 1.282 1.282l1.812-1.69c.185-.185.273-.462.265-.735v-.029c0-.25-.1-.475-.263-.639l-.002-.002-1.812-1.812a.906.906 0 0 0-1.282 0"
      />
    </SvgIcon>
  );
});

export const ActiveJobIcon = forwardRef<SVGSVGElement, SvgIconProps>((props, ref) => {
  const { sx, ...other } = props;

  return (
    <SvgIcon
      ref={ref}
      sx={[
        () => ({
          ...baseStyles,
          color: '#9747FF',
        }),
        ...(Array.isArray(sx) ? sx : [sx]),
      ]}
      {...other}
      viewBox="0 0 58 58"
    >
      <path
        fill="var(--color, currentColor)"
        d="M5.225 20.542c-.392 2.665-.392 6.162-.392 10.874 0 9.114 0 13.672 2.833 16.501 2.83 2.833 7.387 2.833 16.5 2.833h9.667c9.114 0 13.672 0 16.501-2.833 2.833-2.83 2.833-7.387 2.833-16.5 0-4.713 0-8.21-.392-10.876-5.502 3.577-9.029 5.856-12.296 7.263V29a1.812 1.812 0 1 1-3.625.038 30.8 30.8 0 0 1-15.708 0A1.813 1.813 0 0 1 17.52 29V27.8c-3.267-1.401-6.791-3.683-12.296-7.26"
        opacity={0.32}
      />
      <path
        fill="var(--color, currentColor)"
        fillRule="evenodd"
        d="M25.57 5.437h-.048c-.275 0-.488 0-.69.012a6.65 6.65 0 0 0-5.765 4.157q-.154.41-.29.83l-.01.028a3.94 3.94 0 0 1-1.22 1.68 59 59 0 0 0-1.575.072c-3.973.232-6.494.885-8.309 2.7a7.2 7.2 0 0 0-1.426 2.025q.213.072.402.196c5.075 3.298 8.265 5.365 10.913 6.686a1.813 1.813 0 0 1 3.594.344v1.106a27.17 27.17 0 0 0 15.708 0v-1.106a1.812 1.812 0 0 1 3.591-.344c2.651-1.324 5.841-3.388 10.916-6.686q.19-.123.404-.196a7.3 7.3 0 0 0-1.43-2.025c-1.813-1.813-4.334-2.465-8.307-2.702a81 81 0 0 0-1.493-.068 4.55 4.55 0 0 1-1.363-1.87l-.01-.022c-.087-.259-.155-.462-.23-.65a6.65 6.65 0 0 0-5.763-4.155q-.345-.015-.691-.012zm10.24 6.202-.012-.027-.012-.029-.012-.029-.007-.024-.005-.012-.01-.03-.01-.028-.004-.015-.008-.02-.004-.016-.005-.014a9 9 0 0 0-.152-.438 3.02 3.02 0 0 0-2.62-1.89 10 10 0 0 0-.52-.005h-6.858c-.346 0-.443 0-.52.005a3.02 3.02 0 0 0-2.62 1.89l-.007.017-.02.05q-.1.277-.188.557l-.002.014-.007.017-.005.02-.005.014-.01.029-.012.029-.002.012-.01.024-.012.03-.01.028-.012.024q-.05.133-.106.264l2.144-.003h11.832a7 7 0 0 1-.189-.444"
        clipRule="evenodd"
      />
    </SvgIcon>
  );
});

export const AutomationRateIcon = forwardRef<SVGSVGElement, SvgIconProps>((props, ref) => {
  const { sx, ...other } = props;

  return (
    <SvgIcon
      ref={ref}
      sx={[
        () => ({
          ...baseStyles,
          color: '#9747FF',
        }),
        ...(Array.isArray(sx) ? sx : [sx]),
      ]}
      {...other}
      viewBox="0 0 59 58"
    >
      <path
        fill="var(--color, currentColor)"
        d="M33.672 40.257a13.5 13.5 0 0 1-.699 2.614l2.837 2.571a17 17 0 0 1-1.373 2.398l-3.643-1.175a13.6 13.6 0 0 1-1.92 1.92l1.174 3.643c-.756.523-1.56.975-2.398 1.374l-2.571-2.837a13.5 13.5 0 0 1-2.614.698l-.81 3.749c-.457.036-.916.07-1.384.07s-.927-.034-1.386-.07l-.809-3.749a13.5 13.5 0 0 1-2.614-.699l-2.57 2.838a17 17 0 0 1-2.399-1.374l1.175-3.643a13.7 13.7 0 0 1-1.92-1.92L6.106 47.84a17 17 0 0 1-1.373-2.398l2.837-2.57a13.5 13.5 0 0 1-.699-2.615l-3.748-.809c-.036-.458-.07-.918-.07-1.386s.034-.927.07-1.385l3.748-.81a13.5 13.5 0 0 1 .699-2.613l-2.837-2.571c.397-.837.85-1.642 1.373-2.398l3.644 1.174a13.6 13.6 0 0 1 1.92-1.919l-1.175-3.643c.756-.523 1.56-.975 2.398-1.374l2.571 2.837a13.5 13.5 0 0 1 2.614-.698l.81-3.748c.457-.037.916-.07 1.384-.07s.927.033 1.386.07l.809 3.748c.904.148 1.778.382 2.614.698l2.57-2.837c.838.398 1.643.851 2.399 1.374l-1.175 3.643a13.6 13.6 0 0 1 1.92 1.92l3.643-1.174c.523.756.975 1.56 1.374 2.398l-2.838 2.57c.316.836.551 1.71.699 2.614l3.748.81c.036.457.07.917.07 1.385s-.034.927-.07 1.385zM20.27 29a9.06 9.06 0 0 0-9.062 9.063 9.06 9.06 0 0 0 9.062 9.062 9.06 9.06 0 0 0 9.063-9.062A9.06 9.06 0 0 0 20.27 29"
      />
      <path
        fill="var(--color, currentColor)"
        d="M46.243 14.776a7.3 7.3 0 0 1-.553 1.342l1.43 2.742a10 10 0 0 1-1.644 1.645l-2.743-1.431a7 7 0 0 1-1.34.554l-.929 2.954a10 10 0 0 1-1.162.074c-.393 0-.78-.029-1.16-.073l-.929-2.954a7.2 7.2 0 0 1-1.34-.554l-2.743 1.43a10 10 0 0 1-1.645-1.644l1.43-2.742a7 7 0 0 1-.553-1.342l-2.954-.928a10 10 0 0 1-.075-1.162c0-.393.03-.779.074-1.16l2.954-.928q.212-.705.554-1.342l-1.431-2.742a10 10 0 0 1 1.645-1.645l2.742 1.431a7 7 0 0 1 1.341-.554l.928-2.954a10 10 0 0 1 1.162-.074c.394 0 .78.029 1.161.073l.928 2.955q.705.211 1.341.553l2.743-1.43c.61.482 1.161 1.033 1.645 1.644l-1.431 2.742q.342.637.553 1.342l2.955.928c.045.382.074.768.074 1.162s-.029.779-.073 1.16zm-6.94-5.713a3.625 3.625 0 1 0 0 7.25 3.625 3.625 0 0 0 0-7.25M53.566 35.227q-.21.756-.588 1.425l.901 1.897q-.617.786-1.403 1.403l-1.897-.902a6.3 6.3 0 0 1-1.425.589l-.705 1.982a8 8 0 0 1-.99.066 8 8 0 0 1-.991-.066l-.705-1.983a6.3 6.3 0 0 1-1.425-.588l-1.897.902a8.2 8.2 0 0 1-1.403-1.403l.901-1.898a6.3 6.3 0 0 1-.588-1.423l-1.983-.705a8 8 0 0 1-.066-.992c0-.336.026-.665.066-.99l1.983-.705q.21-.756.588-1.424l-.901-1.898q.617-.786 1.403-1.403l1.897.902a6.3 6.3 0 0 1 1.425-.588l.705-1.983c.325-.04.654-.067.99-.067.337 0 .666.026.991.066l.705 1.983q.756.21 1.425.588l1.897-.902c.523.41.994.88 1.403 1.403l-.901 1.898c.252.444.448.922.588 1.425l1.983.705c.04.325.066.654.066.99 0 .337-.026.665-.066.99zm-6.108-4.414a2.719 2.719 0 1 0 0 5.437 2.719 2.719 0 0 0 0-5.437"
      />
      <path
        fill="var(--color, currentColor)"
        d="m55.793 4.55-5.42-1.085-1.085 5.42 1.778.356.488-2.44a13.6 13.6 0 0 1 1.342 5.886c0 3.125-1.031 6.063-2.982 8.496l1.415 1.134a15.45 15.45 0 0 0 3.38-9.63c0-2.373-.549-4.713-1.592-6.825l2.32.464zM21.818 12.047l-1.281 1.281 1.231 1.232c-.498-.032-.998-.06-1.497-.06-7.01 0-13.61 3.091-18.105 8.482l1.392 1.16a21.7 21.7 0 0 1 16.713-7.83c.461 0 .922.027 1.382.056l-1.116 1.116 1.281 1.282 3.36-3.36z"
      />
    </SvgIcon>
  );
});

export const InterviewStartIcon = forwardRef<SVGSVGElement, SvgIconProps>((props, ref) => {
  const { sx, ...other } = props;

  return (
    <SvgIcon
      ref={ref}
      sx={[
        () => ({
          ...baseStyles,
          color: '#9747FF',
        }),
        ...(Array.isArray(sx) ? sx : [sx]),
      ]}
      {...other}
      viewBox="0 0 20 20"
    >
      <g fill="var(--color, currentColor)" clipPath="url(#a)">
        <path
          d="M17.531 0h-5.02a2.467 2.467 0 0 0-2.47 2.469v3.57L8.277 8.393a.586.586 0 0 0 .469.938h8.786A2.47 2.47 0 0 0 20 6.862V2.469A2.47 2.47 0 0 0 17.531 0m-2.51 7.448a.586.586 0 1 1 0-1.173.586.586 0 0 1 0 1.173m0-1.883a.586.586 0 0 1 0-1.172.67.67 0 1 0-.67-.67.586.586 0 0 1-1.171.001 1.843 1.843 0 0 1 3.143-1.302 1.843 1.843 0 0 1-1.302 3.143M11.255 10.67H2.47A2.47 2.47 0 0 0 0 13.137v4.394A2.47 2.47 0 0 0 2.469 20h5.02a2.467 2.467 0 0 0 2.47-2.468v-3.57l1.765-2.355a.586.586 0 0 0-.469-.938M4.98 17.175H3.096a.586.586 0 0 1 0-1.172H4.98a.586.586 0 0 1 0 1.172m1.883-2.51H3.096a.586.586 0 0 1 0-1.172h3.766a.586.586 0 0 1 0 1.172"
          opacity={0.32}
        />
        <path d="M.586 9.33h6.276a.586.586 0 0 0 .586-.585v-.818a3.724 3.724 0 0 0-3.72-3.724 2.101 2.101 0 1 0-.007 0A3.724 3.724 0 0 0 0 7.927v.818c0 .323.261.586.585.586M16.28 14.873a2.102 2.102 0 1 0-.007 0 3.724 3.724 0 0 0-3.72 3.723v.818c0 .324.262.586.585.586h6.276a.586.586 0 0 0 .586-.586v-.818a3.724 3.724 0 0 0-3.72-3.723" />
      </g>
      <defs>
        <clipPath id="a">
          <path fill="#fff" d="M0 0h20v20H0z" />
        </clipPath>
      </defs>
    </SvgIcon>
  );
});

export const InitialScreenIcon = forwardRef<SVGSVGElement, SvgIconProps>((props, ref) => {
  const { sx, ...other } = props;

  return (
    <SvgIcon
      ref={ref}
      sx={[
        () => ({
          ...baseStyles,
          color: '#97E038',
        }),
        ...(Array.isArray(sx) ? sx : [sx]),
      ]}
      {...other}
      viewBox="0 0 20 20"
    >
      <path
        fill="var(--color, currentColor)"
        d="m17.258 16.075-2.833-2.825a6.6 6.6 0 0 0 1.408-4.083 6.667 6.667 0 1 0-6.666 6.666 6.6 6.6 0 0 0 4.083-1.408l2.825 2.833a.833.833 0 0 0 1.183 0 .83.83 0 0 0 0-1.183M4.167 9.167a5 5 0 1 1 10 0 5 5 0 0 1-10 0"
      />
      <path
        fill="var(--color, currentColor)"
        d="M9.032 12.377c.037.174.285.174.323 0a3.96 3.96 0 0 1 3.041-3.041c.174-.037.174-.286 0-.323a3.96 3.96 0 0 1-3.041-3.041c-.038-.174-.286-.174-.323 0A3.96 3.96 0 0 1 5.99 9.013c-.173.037-.173.286 0 .323a3.96 3.96 0 0 1 3.042 3.041"
      />
    </SvgIcon>
  );
});